import Index     from "@/views/Denuncia/Index.vue"
import Nova      from "@/views/Denuncia/Nova.vue"
import Protocolo from "@/views/Denuncia/Protocolo.vue"
import Consulta  from "@/views/Denuncia/Consulta.vue"

export default  [
    {
        name: 'den_index',
        path: "/",
		component: Index
    },

    {
        name: "new_denuncia",
        path: "Nova",
		component: Nova
    },

    {
        name: "den_protocolo",
        path: "Protocolo/:protocolo",
        component: Protocolo,
        props: true
    },

    {
        name: "den_consult",
        path: "Consulta",
		component: Consulta
    },
]